import styled from '@emotion/styled';

interface InputProps {
	error?: boolean;
	fullWidth?: boolean;
}
export const Container = styled.main`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 84.4rem;
	padding: 8rem 0;
	margin: 0 auto;
	gap: 8rem;
	@media (max-width: 900px) {
		padding: 8rem 2rem;
	}
`;
export const FormContainer = styled.div`
	width: 100%;
	margin: 0 auto;
`;
export const Form = styled.form`
	display: flex;
	flex-direction: column;
	gap: 32px;
	width: 100%;
	@media (max-width: 900px) {
		gap: 24px;
	}
`;
export const FormGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;
export const Label = styled.label`
	font-size: 1.4rem;
	color: #212529;
	font-weight: 700;
	display: flex;
	align-items: center;
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const Required = styled.span`
	color: #e03131;
	margin-left: 0.2rem;
`;
export const Input = styled.input<InputProps>`
	width: 100%;
	height: 4.4rem;
	padding: 0 1.2rem;
	border: 1px solid #adb5bd;
	font-size: 1.6rem;
	&::placeholder {
		color: #adb5bd;
	}
	&:focus {
		outline: none;
		border-color: ${(props) => (props.error ? '#e03131' : '#228be6')};
	}
`;
export const ErrorText = styled.p`
	font-size: 1.2rem;
	color: #e03131;
	margin-top: 0.4rem;
	margin-bottom: 0;
`;
export const EmailGroup = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 1fr 1fr;
	align-items: center;
	gap: 0.8rem;
`;
export const EmailInput = styled.input<InputProps>`
	flex: 1;
	width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
	height: 4.4rem;
	padding: 0 1.2rem;
	border: 1px solid ${(props) => (props.error ? '#e03131' : props.theme.colors.gray200)};
	font-size: 1.6rem;
	&::placeholder {
		color: #adb5bd;
	}
	&:focus {
		outline: none;
		border-color: ${(props) => (props.error ? '#e03131' : '#228be6')};
	}
`;
export const EmailAt = styled.span`
	font-size: 1.6rem;
	color: #495057;
`;
export const Textarea = styled.textarea`
	width: 100%;
	height: 38.4rem;
	padding: 1.2rem;
	border: 1px solid #adb5bd;
	font-size: 1.6rem;
	resize: none;
	&::placeholder {
		color: #adb5bd;
	}
	&:focus {
		outline: none;
		border-color: #228be6;
	}
`;
export const ButtonArea = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
`;
export const Button = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	width: max-content;
	padding: 1.4rem 1.2rem;
	border: 1px solid ${(props) => props.theme.colors.primary400};
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	background-color: #fff;
	color: ${(props) => props.theme.colors.primary400};
	cursor: pointer;
	&.primary {
		background-color: ${(props) => props.theme.colors.primary400};
		color: #fff;
	}
	&:disabled {
		background-color: ${(props) => props.theme.colors.gray100};
		border: 1px solid ${(props) => props.theme.colors.gray100};
		color: ${(props) => props.theme.colors.gray200};
		cursor: auto;
	}
`;
